// extracted by mini-css-extract-plugin
export default {"brandPromo":"jH-z","carousel":"kH-z"};